import { render, staticRenderFns } from "./TorrentClients.vue?vue&type=template&id=33f1f8ca&lang=pug&"
import script from "./TorrentClients.vue?vue&type=script&lang=js&"
export * from "./TorrentClients.vue?vue&type=script&lang=js&"
import style0 from "./TorrentClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports